// import libaries
import axios from "axios";
// files
import i18n from "../i18n";
import { env } from "../env";
import { getBearerToken } from "../api/apiService";
import { LANGUAGE_STORAGE_KEY, normalizeLanguageCode } from "../i18n";

const buildApiUrl = (path) => {
    const rawBase = String(env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
    if (!rawBase) {
        return `/api/${path}`;
    }
    return rawBase.endsWith("/api") ? `${rawBase}/${path}` : `${rawBase}/api/${path}`;
};

const mapTranslationsToDictionary = (list, language) => {
    return list.reduce((dictionary, item) => {
        const key = String(item?.key || "").trim();
        if (!key) return dictionary;

        const value = String(item?.value || "").trim();
        const defaultValue = String(item?.defaultvalue || "").trim();

        dictionary[key] = value || defaultValue || key;
        return dictionary;
    }, {});
};

export const loadTranslations = async (lang) => {
    const language = normalizeLanguageCode(lang);
    const cacheKey = `authTranslations_${language}`;
    const stored = localStorage.getItem(cacheKey);

    if (stored) {
        try {
            const dictionary = JSON.parse(stored);
            i18n.addResourceBundle(language, "translation", dictionary, true, true);
        } catch {
            localStorage.removeItem(cacheKey);
        }
    }

    const token = getBearerToken();

    if (!token) {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        await i18n.changeLanguage(language);
        return;
    }

    try {
        const response = await axios.get(
            buildApiUrl("SystemTranslation/GetTranslationKeyValue"),
            {
                headers: { Authorization: `Bearer ${token}` },
                params: { language }
            }
        );

        const list = Array.isArray(response?.data) ? response.data : [];
        const dictionary = mapTranslationsToDictionary(list, language);

        localStorage.setItem(cacheKey, JSON.stringify(dictionary));
        i18n.addResourceBundle(language, "translation", dictionary, true, true);
    } catch (error) {
        console.error("[Translation] ERROR", error);
    } finally {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        await i18n.changeLanguage(language);
    }
};
